module.exports = __webpack_public_path__ + "static/media/heart.9575be0c.svg";